import { ReactNode } from "react";
import { useIntl } from "react-intl";

import Callout from "@aglocal/web/components/Callout";
import RetryAction from "@aglocal/web/components/RetryAction";
import TeamsBackground from "@/components/TeamsBackground";

export interface ErrorPageProps {
  title: string;
  children?: ReactNode;
}

export default function ErrorPage(props: ErrorPageProps) {
  const { $t } = useIntl();
  return (
    <TeamsBackground>
      <Callout
        intent="error"
        actions={
          <RetryAction>
            {$t({
              defaultMessage: "Retry",
              description: "Button that reloads the page after an error.",
            })}
          </RetryAction>
        }
        {...props}
      />
    </TeamsBackground>
  );
}
